import React from "react";
import {isSet} from "../services/commonUtil.js";


const formatPrice = (price) => (Math.round(price * 100) / 100).toFixed(2);

const CPrice = (props) => {
    var {price, oldPrice, currency} = props;
    var currencyString = currency === 'EUR' ? '€' : currency;
    if (!isSet(price) || !isSet(currency)) {
        console.warn(`CPrice : missing price or currency`);
        return null;
    }
    return (<>
        {isSet(oldPrice) && price !== oldPrice ? (<s>{formatPrice(oldPrice)}</s>) : null}
        &#160;<span className="select-all-text">{formatPrice(price)}&#160;{currencyString}</span>
    </>);
}

export default CPrice;